






































import Vue from 'vue';
import { AppUser } from '../types';
import recognition from './recognition';
import { logout } from './index';

interface Data {
  task: Promise<void>|null,
  loading: boolean,
  isAuthenticated: boolean,
  accountName: string|null,
  appUser: AppUser|null,
}

export default Vue.extend({
  data(): Data {
    return {
      task: null,
      loading: false,
      isAuthenticated: recognition.isAuthenticated(),
      accountName: recognition.getAccountName(),
      appUser: recognition.getAppUser(),
    };
  },
  watch: {
    task: {
      handler(newTask) {
        if (!newTask) return;
        this.loading = true;
        newTask.finally(() => {
          this.loading = false;
        });
      },
      immediate: true,
    },
  },
  computed: {
    userInfoLabel(): string {
      if (!this.appUser) return '';
      return `Hi, ${this.appUser.firstName} ${this.appUser.lastName}`;
    },
  },
  methods: {
    onLogout(): void {
      this.task = logout();
      if (this.task) {
        this.task.then(() => {
          this.$router.push({ name: 'login' });
        });
      }
    },
  },
});
